import {
  SelectInput,
  SimpleForm,
  TextInput,
  PasswordInput,
  useRecordContext,
  useGetOne,
} from 'react-admin';
import { useBillerPaymentGateways } from './BillerMerchantCodesFilters';

interface BillerMerchantCodeFormProps {
  onSubmit?: (data: any) => void;
}

const BillerMerchantCodeForm = ({ onSubmit }: BillerMerchantCodeFormProps) => {
  const record = useRecordContext();
  const { paymentGateways, loading: isLoadingGateways } = useBillerPaymentGateways();

  console.log('Form record context:', record);
  console.log('Payment gateways:', paymentGateways);
  console.log('Is loading gateways:', isLoadingGateways);

  if (isLoadingGateways) {
    console.log('Loading payment gateways...');
    return <div>Loading payment gateways...</div>;
  }

  const handleSubmit = (data: any) => {
    console.log('Form submitted with data:', data);
    if (onSubmit) {
      onSubmit(data);
    }
  };

  return (
    <SimpleForm onSubmit={handleSubmit}>
      <SelectInput
        source="paymentGateway"
        label="Payment Gateway"
        choices={paymentGateways?.map((pg: any) => ({
          id: pg.pgName,
          name: pg.pgName,
        })) || []}
        optionText="name"
        optionValue="id"
        fullWidth
        disabled={!paymentGateways?.length}
      />
      <TextInput source="merchantId" label="Merchant ID" fullWidth />
      <TextInput source="clientKey" label="Client Key" fullWidth />
      <TextInput source="secretKey" label="Secret Key" fullWidth />
      <TextInput source="userName" label="Username" fullWidth />
      <PasswordInput source="password" label="Password" fullWidth />
    </SimpleForm>
  );
};

export default BillerMerchantCodeForm;
